import axios from 'axios';
import errorTemplate from '../../sections/how-to-buy/templates/error.twig';
import FileInput from './file';
import notFoundTemplate from '../../sections/how-to-buy/templates/not-found.twig';
import Observer from '../../common/scripts/observer';
import successTemplate from '../../sections/how-to-buy/templates/success.twig';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Form {
    init(options) {
        this.wrapper = options.target;
        this.popupInstance = options.popupInstance || null;
        this.form = options.target.querySelector('form');
        this.isCustomHide = this.form.dataset.customHide || false;
        this.isVaildation = 'validate' in this.form.dataset;
        this.successMessage = options.successMessage;
        this.action = this.form.getAttribute('action');
        this.messageBot = this.form.querySelector('[name="message_bot"]');
        this.readyClass = 'is-ready';
        this.showClass = 'is-active';
        this.errorClass = 'is-error';
        this.disabledClass = 'is-disabled';
        this.hideClass = 'is-hide';

        this._getElements();
        this._subscribes();
        this._bindEvents();

        this._setHiddenInputs();
        this._setFlatDetails();
        this._setPantryDetails();
        this._setHiddenUrl();
    }

    /**
     * Метод получает дом элементы.
     * @protected
     */
    _getElements() {
        this.submit = this.form.querySelector('.j-form-submit');
        this.repeatButtons = Array.from(this.wrapper.querySelectorAll('.j-form-repeat'));
        this.submitText = this.submit?.querySelector('span');
        this.submitSendText = this.submit?.dataset.sendText;
        this.submitSuccessText = this.submit?.dataset.successText;
        this.submitErrorText = this.submit?.dataset.errorText;
        this.formId = this.form?.getAttribute('id') || '';
        this.files = Array.from(this.form.querySelectorAll('.j-form__file'));
        this.agreementCheckboxes = Array.from(this.form.querySelectorAll('.agreement-checkbox'));

        if (this.successMessage) {
            this.successMessageWrap = this.wrapper.querySelector('.j-form-success');
            this.errorMessageWrap = this.wrapper.querySelector('.j-form-error');
        }

        this._disableSubmit();
    }

    _disableSubmit() {
        if (!this.agreementCheckboxes.length || !this.submit) {
            return;
        }

        const updateSubmitState = () => {
            this.submit.disabled = !this._areAgreementCheckboxesValid();
        };

        updateSubmitState();

        this.agreementCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', updateSubmitState);
        });
    }

    _areAgreementCheckboxesValid() {
        if (!this.agreementCheckboxes.length) {
            return true;
        }

        return this.agreementCheckboxes.every((checkbox) => {
            return checkbox.checked;
        });
    }

    _subscribes() {
        if (this.isVaildation) {
            observer.subscribe('formIsValid', (form) => {
                if (form === this.form) {
                    this._send();
                }
            });
        }
    }

    /**
     * Метод навешивает обработчики событий.
     * @private
     */
    _bindEvents() {
        if (!this.isVaildation) {
            if (this.submit) {
                this.submit.addEventListener('click', (event) => {
                    event.preventDefault();
                    this._send();
                });
            }
        }

        this.repeatButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this._showRepeatForm();
            });
        });

        this.files.forEach((file) => {
            const newFile = new FileInput({
                elem: file
            });

            newFile.init();
        });
    }

    /**
     * Метод оптправляет данные на сервер.
     * @private
     */
    _send() {
        if (this._isAllReady()) {
            return;
        }

        if (!this._areAgreementCheckboxesValid()) {
            return;
        }

        this._insertAntiSpam();
        this.formData = new FormData(this.form);
        this.formDataObject = {};
        this.formData.forEach((value, key) => {
            this.formDataObject[key] = value;
        });
        this._insertButtonText(this.submitSendText);

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.post(this.action, this.formData)
            .then((response) => {
                const status = response.data.success;

                if (status) {
                    this._sendIsSuccess();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                this._sendIsError();
                console.error(err);
            });
    }

    _isAllReady() {
        return this.wrapper.classList.contains(this.readyClass);
    }

    /**
     * Метод вызывается при успешной отправке запроса.
     * @private
     */
    _sendIsSuccess() {
        this.errorMessageWrap.classList.remove(this.showClass);
        this.submit.classList.remove(this.errorClass);

        this._showSuccessMessage();
        this._insertButtonText(this.submitSuccessText);
        this.submit.classList.add(this.disabledClass);
    }

    /**
     * Метод вызывается при ошибке отправки запроса.
     * @private
     */
    _sendIsError() {
        this._insertButtonText(this.submitErrorText);
        this.submit.classList.add(this.errorClass);

        this._showErrorMessage();
    }

    /**
     * Показывает сообщение об успешной отправкой формы.
     * @private
     */
    _showSuccessMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList.add(this.showClass);

        if (this.isCustomHide) {
            this.form.classList.add(this.hideClass);
        } else {
            Utils.hide(this.form);
        }

        observer.publish('successForm');
    }

    /**
     * Показывает сообщение об ошибке
     * @private
     */
    _showErrorMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList?.remove(this.showClass);
        this.errorMessageWrap.classList.add(this.showClass);

        if (this.isCustomHide) {
            this.form.classList.add(this.hideClass);
        } else {
            Utils.hide(this.form);
        }

        observer.publish('errorForm');
    }

    /**
     * Повторно показывает форму, скрывая успех/ошибку
     * @private
     */
    _showRepeatForm() {
        const successInputs = this.form.querySelectorAll('.validate-input-success');

        this.wrapper.classList?.remove(this.readyClass);
        this.successMessageWrap.classList?.remove(this.showClass);
        this.errorMessageWrap.classList?.remove(this.showClass);
        this.form.reset();

        if (successInputs) {
            successInputs.forEach((element) => {
                element.classList.remove('validate-input-success');
            });
        }

        if (this.isCustomHide) {
            this.form.classList?.remove(this.hideClass);
        } else {
            Utils.show(this.form);
        }
    }

    /**
     * Метод вставляет текст в кнопку сабмит.
     * @param {string} text - необходимый текст.
     * @private
     */
    _insertButtonText(text) {
        Utils.clearHtml(this.submitText);
        Utils.insetContent(this.submitText, text);
    }

    /**
     * Метод вставляет скрытое поле с антиспамом
     */
    _insertAntiSpam() {
        if (this.messageBot) {
            const minRandom = 1;
            const maxRandom = 10;

            this.messageBot.value = `nospam ${Utils.random(minRandom, maxRandom)}`;
        }
    }

    /**
     * Возвращает ноду для скрытого инпута.
     * По необходимости (по флагу дата-атрибута) -- создаёт инпут
     * @param {string} inputName - название инпута
     * @return {HTMLInputElement|null} - инпут
     * @private
     */
    _getHiddenInputNode(inputName) {
        const shouldCreateInput = this.popupInstance.currentTarget.getAttributeNames()
            .includes('data-should-create-inputs');
        let input = this.form.querySelector(`input[class="${inputName}"]`);

        if (input) {
            return input;
        }

        if (!shouldCreateInput) {
            return null;
        }

        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        input.classList.add(inputName);

        this.form.appendChild(input);

        return input;
    }

    /**
     * Устанавливает данные скрытому инпуту исходя из таргета попапа
     * @private
     */
    _setHiddenInputs() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }
        const inputs = this.popupInstance.currentTarget.dataset.inputs;

        if (inputs) {
            const inputsArray = inputs.split(',');

            for (const item of inputsArray) {
                const data = item.split(':');
                const input = this._getHiddenInputNode(data[0]);

                if (input) {
                    input.value = data[1];
                }
            }
        }
    }

    /**
     * Выводит данные о кладовке в попап исходя из таргета попапа
     * @private
     */
    _setFlatDetails() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }
        const inputs = this.popupInstance.currentTarget.dataset.inputs;
        const details = this.wrapper.querySelectorAll('.popup__compare-flat-details-item');

        if (inputs && details) {
            const inputsArray = inputs.split(',');

            for (const item of inputsArray) {
                const data = item.split(':');

                details.forEach((node) => {
                    if (node.classList.contains(`popup__compare-flat-details-${data[0]}`) && data[1]) {
                        node.innerHTML = data[1] + node.innerHTML;
                    }
                });
            }
        }
    }

    /**
     * Выводит данные о кладовке в попап исходя из таргета попапа
     * @private
     */
    _setPantryDetails() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }
        const inputs = this.popupInstance.currentTarget.dataset.inputs;
        const details = this.wrapper.querySelectorAll('.popup__pantry-details-item');

        if (inputs && details) {
            const inputsArray = inputs.split(',');

            for (const item of inputsArray) {
                const data = item.split(':');

                details.forEach((node) => {
                    if (node.classList.contains(`popup__pantry-details-${data[0]}`) && data[1]) {
                        node.innerHTML = data[1] + node.innerHTML;
                    }
                });
            }
        }
    }

    /**
     * При необходимости устанавливает текущий url в скрытый инпут
     * @private
     */
    _setHiddenUrl() {
        const input = this.form.querySelector('input[name=url]');

        if (input) {
            input.value = window.location.href;
        }
    }
}

//
// Форма для Ипотеки -> Trade-in
//
export class TradeInForm extends Form {
    /**
     * @Override
     * @protected
     */
    _getElements() {
        super._getElements();

        this.parentWrapper = document.querySelector('.j-trade-in-forms');

        if (this.successMessage && this.parentWrapper.contains(this.wrapper)) {
            this.successMessageWrap = this.parentWrapper.querySelector('.j-form-success');
            this.errorMessageWrap = this.parentWrapper.querySelector('.j-form-error');
            this.serverContentWrap = this.parentWrapper.querySelector('.j-form-server-content');
        }
    }

    /**
     * @Override
     * @private
     */
    _send() {
        if (!this._areAgreementCheckboxesValid()) {
            return;
        }

        this.parentWrapper?.classList?.remove('has-result');
        this.serverContentWrap?.classList?.remove('is-active');
        Utils.clearHtml(this.serverContentWrap);

        this._insertAntiSpam();
        this.formData = new FormData(this.form);
        this.formDataObject = {};
        this.formData.forEach((value, key) => {
            this.formDataObject[key] = value;
        });
        this._insertButtonText(this.submitSendText);

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.post(this.action, this.formData)
            .then((response) => {
                const status = response.status;
                const data = response.data;
                const isSuccess = data?.success;

                if (isSuccess) {
                    this._sendIsSuccess(data);
                    this.parentWrapper?.classList?.add('has-result');
                } else if (status === 404) {
                    this._sendIsNotFound();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                if (err.message.includes('404')) {
                    this._sendIsNotFound();
                } else {
                    this._sendIsError();
                    console.error(err);
                }
            })
            .finally(() => {
                this.serverContentWrap?.classList?.add('is-active');
            });
    }

    /**
     * @Override
     * Метод вызывается при успешной отправке запроса.
     * @private
     */
    _sendIsSuccess(data) {
        this.errorMessageWrap.classList.remove(this.showClass);
        this.submit.classList.remove(this.errorClass);

        this._showSuccessMessage();
        this._insertButtonText(this.submitSuccessText);

        Utils.insetContent(this.serverContentWrap, successTemplate(data));
    }

    _sendIsNotFound() {
        this._insertButtonText(this.submitErrorText);
        this.submit.classList.add(this.errorClass);

        this._showErrorMessage();

        Utils.insetContent(this.serverContentWrap, notFoundTemplate());
    }

    /**
     * @Override
     * Метод вызывается при ошибке отправки запроса.
     * @private
     */
    _sendIsError() {
        this._insertButtonText(this.submitErrorText);
        this.submit.classList.add(this.errorClass);

        this._showErrorMessage();

        Utils.insetContent(this.serverContentWrap, errorTemplate());
    }
}

export default Form;
